export default __webpack_public_path__ + "images/NIS.96d723c.png";